module.exports = __webpack_public_path__ + "static/media/Dubai_manufacturing_business_guide_wbn_b2b_export_suppliers.e381352c.svg";